import {
  // ── Common Icons ──
  Megaphone,
  Users,
  Users2,
  MessageSquare,
  User,
  Building,
  Building2,       // ✅ missing
  Star,
  BookUser,
  ClipboardList,
  CheckCircle,
  UserCheck,
  Video,
  Image as ImgIcon,
  Lightbulb,
  Tv2,
  BookOpen,
  PieChart,
  Award,
  DollarSign,
  Check,
  Handshake,
  FileText,
  Calendar,
  Rocket,
  ListChecks,
  LineChart,
  BarChart3,
  UserCog,
  Newspaper,
  Settings,
  CalendarClock,
  Download,
  GraduationCap,
  Cpu,
  Briefcase,
  ShoppingBag,
  Zap,
  MonitorPlay,
  Search,
  LayoutGrid,
  Sparkles,
  Rows,
  Columns,
  Expand,
  Shrink,
  BarChart,
  ChartPie,
  Wallet,
  Globe2,
  Share2,
  UsersRound,
  BookMarked,       
  Presentation,     
  Mic, 
  LibraryIcon,  
  NewspaperIcon,  
  SatelliteDishIcon,
  LayoutDashboardIcon,        
} from "lucide-react";
export const iconCls = "w-5 h-5";

export const ZONES = [
  { key: "office", title: "Dashboard", icon: <LayoutDashboardIcon className={iconCls} />, color: "#c084fc" },
  { key: "tools", title: "Market Tools", icon: <BarChart3 className={iconCls} />, color: "#f472b6" },
  { key: "marketplace", title: "Marketplace", icon: <ShoppingBag className={iconCls} />, color: "#4ade80" },
  { key: "community", title: "Community", icon: <Users2 className={iconCls} />, color: "#60a5fa" },
  { key: "directory", title: "Directory", icon: <UserCheck className={iconCls} />, color: "#60cdfa" },
  { key: "jobs", title: "Job Board", icon: <Globe2 className={iconCls} />, color: "#06b6d4" },
  { key: "face", title: "Market Face", icon: <Share2 className={iconCls} />, color: "#fbbf24" },
  { key: "academics", title: "Academics", icon: <GraduationCap className={iconCls} />, color: "#f59e42" },
  { key: "funding", title: "Funding", icon: <DollarSign className={iconCls} />, color: "#facc15" },
  { key: "deal", title: "Deal Desk", icon: <Handshake className={iconCls} />, color: "#a3e635" },
  { key: "freelance", title: "Freelancer", icon: <UserCog className={iconCls} />, color: "#facc15" },
  { key: "appoint", title: "Appointment", icon: <CalendarClock className={iconCls} />, color: "#818cf8" },
  { key: "expert", title: "Expert Room", icon: <Star className={iconCls} />, color: "#fbbf24" },
  { key: "launch", title: "Launch", icon: <Zap className={iconCls} />, color: "#f59e42" },
  { key: "signals", title: "Signals", icon: <Megaphone className={iconCls} />, color: "#f472b6" },
  { key: "invest", title: "Investment", icon: <BarChart3 className={iconCls} />, color: "#4ade80" },
  { key: "media", title: "Media", icon: <SatelliteDishIcon className={iconCls} />, color: "#38bdf8" },
  { key: "expo", title: "Market Expo", icon: <MonitorPlay className={iconCls} />, color: "#fbbf24" },
  { key: "library", title: "Library", icon: <LibraryIcon className={iconCls} />, color: "#fbbf24" },
  { key: "news", title: "Live News", icon: <NewspaperIcon className={iconCls} />, color: "#fbbf24" },
];

// 👇 SUBMENUS
export const SUBMENUS = {
  office: [
    {
      label: "Profile Controls",
      icon: <User className={iconCls} />,
      children: [
        { label: "Overview" },
        { label: "SmartCard" },
        { label: "KYC & Verification" },
        { label: "Preferences" },
        { label: "Connected Accounts" },
      ],
    },
    {
      label: "Content Controls",
      icon: <ClipboardList className={iconCls} />,
      children: [
        { label: "My Tools" },
        { label: "My Signals" },
        { label: "My Courses" },
        { label: "My Services" },
        { label: "My Media" },
        { label: "My Directory" },
        { label: "My Deals" },
        { label: "My Launches" },
        { label: "My Funding" },
      ],
    },
    {
      label: "Business Controls",
      icon: <BarChart3 className={iconCls} />,
      children: [
        { label: "Insights & Analytics" },
        { label: "Wallet & Payouts" },
        { label: "Subscriptions" },
        { label: "Affiliate Program" },
        { label: "Boosters" },
        { label: "Orders & Purchases" },
      ],
    },
    {
      label: "Upgrade & Access",
      icon: <Award className={iconCls} />,
      children: [
        { label: "Upgrade Membership" },
        { label: "Unlock AI Tools" },
        { label: "Monetize Content" },
        { label: "Create Booster Ads" },
        { label: "Enable Business Access" },
      ],
    },
    {/*
    {
      label: "Admin Controls",
      icon: <Settings className={iconCls} />,
      children: [
        { label: "User Verification" },
        { label: "Category Requests" },
        { label: "Reports & Abuse" },
        { label: "Platform Announcements" },
        { label: "Revenue Dashboard" },
        { label: "Role Directory Control" },
      ],
    },
    */}
  ],

  tools: [
    {
      label: "Charts",
      icon: <BarChart3 className={iconCls} />,
      children: [
        { label: "TradingView" },
        { label: "MetaTrader 4 (MT4)" },
        { label: "MetaTrader 5 (MT5)" },
        { label: "cTrader" },
        { label: "NinjaTrader" },
        { label: "ThinkorSwim" },
        { label: "Custom Chart" },
      ],
    },
    {
      label: "Signals",
      icon: <Megaphone className={iconCls} />,
      children: [
        { label: "Copy Signals" },
        { label: "Community Signals" },
        { label: "Premium Alerts" },
        { label: "My Signal Room" },
        {
          label: "Free Signals",
          children: [{ label: "TradingView Signals" }],
        },
      ],
    },
    {
      label: "Calendars",
      icon: <CalendarClock className={iconCls} />,
      children: [
        { label: "Economic Calendar" },
        { label: "Earnings Calendar" },
        { label: "Event Calendar" },
      ],
    },
    {
      label: "Screeners",
      icon: <ListChecks className={iconCls} />,
      children: [
        { label: "Forex Screener" },
        { label: "Crypto Screener" },
        { label: "Stocks Screener" },
        { label: "Commodities Screener" },
      ],
    },
    {
      label: "Backtests",
      icon: <BarChart className={iconCls} />,
      children: [
        { label: "Strategy Tester" },
        { label: "AI Backtest" },
        { label: "Portfolio Replay" },
      ],
    },
  ],

  marketplace: [
    {
      label: "Tools",
      icon: <Cpu className={iconCls} />,
      children: [
        { label: "Indicators & Scripts" },
        { label: "Strategies & Systems" },
        { label: "Plugins & Utilities" },
        { label: "Data Connectors" },
        { label: "Multi-Platform Tools" },
      ],
    },
    {
      label: "Services",
      icon: <UserCog className={iconCls} />,
      children: [
        { label: "Trading & Analysis" },
        { label: "Development & Automation" },
        { label: "Broker & Compliance" },
        { label: "Marketing & Branding" },
        { label: "Support & Maintenance" },
      ],
    },
    {
      label: "Downloads",
      icon: <Download className={iconCls} />,
      children: [
        { label: "Data Packs" },
        { label: "Templates & Layouts" },
        { label: "Spreadsheets & Tools" },
        { label: "Reports & Research" },
        { label: "Libraries & Code" },
      ],
    },
    {
      label: "Courses & Mentorship",
      icon: <GraduationCap className={iconCls} />,
      children: [
        { label: "Trading & Investing" },
        { label: "Algo & Quant" },
        { label: "Career & Certification" },
        { label: "Mentorship Tracks" },
      ],
    },
    {
      label: "Hire / Freelance",
      icon: <Briefcase className={iconCls} />,
      children: [
        { label: "Hire a Developer" },
        { label: "Hire a Mentor" },
        { label: "Hire a Researcher" },
        { label: "Hire a Designer / Marketer" },
        { label: "Post a Job or Gig" },
      ],
    },
  ],

    // 🟢 Community
  community: [
    {
      label: "Feeds",
      icon: <Megaphone className={iconCls} />,
      children: [
        { label: "Market Updates" },
        { label: "User Stories" },
        { label: "Educational Feeds" },
        { label: "Sponsored Posts" },
      ],
    },
    {
      label: "Groups",
      icon: <Users className={iconCls} />,
      children: [
        { label: "Trading Groups" },
        { label: "Investment Clubs" },
        { label: "Learning Circles" },
        { label: "Regional Communities" },
      ],
    },
    {
      label: "DMs",
      icon: <MessageSquare className={iconCls} />,
      children: [
        { label: "Inbox" },
        { label: "Sent" },
        { label: "Archived" },
      ],
    },
    {
      label: "Rooms",
      icon: <UsersRound className={iconCls} />,
      children: [
        { label: "Live Discussion Rooms" },
        { label: "Voice Rooms" },
        { label: "Event Rooms" },
      ],
    },
  ],

  // 🟣 Directory
  directory: [
    {
      label: "People",
      icon: <User className={iconCls} />,
      children: [
        { label: "Traders" },
        { label: "Analysts" },
        { label: "Investors" },
        { label: "Educators" },
      ],
    },
    {
      label: "Companies",
      icon: <Building2 className={iconCls} />,
      children: [
        { label: "Brokers" },
        { label: "Fintechs" },
        { label: "Startups" },
        { label: "Institutions" },
      ],
    },
    {
      label: "Experts",
      icon: <Star className={iconCls} />,
      children: [
        { label: "Advisors" },
        { label: "Consultants" },
        { label: "Auditors" },
        { label: "Mentors" },
      ],
    },
    {
      label: "Institutions",
      icon: <BookUser className={iconCls} />,
      children: [
        { label: "Universities" },
        { label: "Research Centers" },
        { label: "Accredited Firms" },
      ],
    },
  ],

  // 🔵 Jobs
  jobs: [
    {
      label: "Jobs",
      icon: <ClipboardList className={iconCls} />,
      children: [
        { label: "Full-Time" },
        { label: "Part-Time" },
        { label: "Internships" },
      ],
    },
    {
      label: "Gigs",
      icon: <CheckCircle className={iconCls} />,
      children: [
        { label: "Freelance Gigs" },
        { label: "One-Time Tasks" },
      ],
    },
    {
      label: "Hire",
      icon: <UserCheck className={iconCls} />,
      children: [
        { label: "Post a Job" },
        { label: "Talent Search" },
      ],
    },
    {
      label: "Applicants",
      icon: <Users2 className={iconCls} />,
      children: [
        { label: "Received Applications" },
        { label: "Shortlisted" },
        { label: "Interview Scheduled" },
      ],
    },
  ],

  // 🟠 Market Face
  face: [
    {
      label: "Reels",
      icon: <Video className={iconCls} />,
      children: [
        { label: "Market Moments" },
        { label: "Educational Shorts" },
        { label: "Product Demos" },
      ],
    },
    {
      label: "Images",
      icon: <ImgIcon className={iconCls} />,
      children: [
        { label: "Charts" },
        { label: "Market Infographics" },
        { label: "Events" },
      ],
    },
    {
      label: "Insights",
      icon: <Lightbulb className={iconCls} />,
      children: [
        { label: "Analyst Insights" },
        { label: "Community Thoughts" },
      ],
    },
    {
      label: "Live",
      icon: <Tv2 className={iconCls} />,
      children: [
        { label: "Streaming" },
        { label: "Webinars" },
      ],
    },
  ],

  // 🟡 Academics
  academics: [
    {
      label: "Courses",
      icon: <BookOpen className={iconCls} />,
      children: [
        { label: "Trading Basics" },
        { label: "Advanced Investing" },
        { label: "Technical Analysis" },
        { label: "Algo Development" },
      ],
    },
    {
      label: "Webinars",
      icon: <Video className={iconCls} />,
      children: [
        { label: "Upcoming" },
        { label: "Recorded" },
      ],
    },
    {
      label: "Tracks",
      icon: <PieChart className={iconCls} />,
      children: [
        { label: "Career Tracks" },
        { label: "Mentorship Paths" },
      ],
    },
    {
      label: "Certificates",
      icon: <Award className={iconCls} />,
      children: [
        { label: "Enrollments" },
        { label: "Completed" },
      ],
    },
  ],

  // 💸 Funding
  funding: [
    {
      label: "Programs",
      icon: <BookMarked className={iconCls} />,
      children: [
        { label: "Incubators" },
        { label: "Accelerators" },
        { label: "Crowdfunding" },
      ],
    },
    {
      label: "VCs",
      icon: <DollarSign className={iconCls} />,
      children: [
        { label: "Angel Investors" },
        { label: "Venture Firms" },
      ],
    },
    {
      label: "Pitch",
      icon: <Presentation className={iconCls} />,
      children: [
        { label: "Pitch Decks" },
        { label: "Demo Days" },
      ],
    },
    {
      label: "Grants",
      icon: <Check className={iconCls} />,
      children: [
        { label: "Government" },
        { label: "Private" },
      ],
    },
  ],

  // 🤝 Deal Desk
  deal: [
    {
      label: "Deals",
      icon: <Handshake className={iconCls} />,
      children: [
        { label: "Open Deals" },
        { label: "Closed Deals" },
      ],
    },
    {
      label: "Partners",
      icon: <Users className={iconCls} />,
      children: [
        { label: "Verified Partners" },
        { label: "Pending Partnerships" },
      ],
    },
    {
      label: "RFPs",
      icon: <FileText className={iconCls} />,
      children: [
        { label: "Active Requests" },
        { label: "Submitted Proposals" },
      ],
    },
  ],

  // 🧩 Freelance
  freelance: [
    {
      label: "Services",
      icon: <ClipboardList className={iconCls} />,
      children: [
        { label: "Design" },
        { label: "Development" },
        { label: "Marketing" },
        { label: "Writing" },
      ],
    },
    {
      label: "Offers",
      icon: <DollarSign className={iconCls} />,
      children: [
        { label: "Promotional Offers" },
        { label: "Discounts" },
      ],
    },
    {
      label: "Portfolio",
      icon: <User className={iconCls} />,
      children: [
        { label: "My Projects" },
        { label: "Client Reviews" },
      ],
    },
  ],

  // 📅 Appointment
  appoint: [
    {
      label: "Calendar",
      icon: <Calendar className={iconCls} />,
      children: [
        { label: "My Schedule" },
        { label: "Team Meetings" },
      ],
    },
    {
      label: "Bookings",
      icon: <BookUser className={iconCls} />,
      children: [
        { label: "Consultations" },
        { label: "Sessions" },
      ],
    },
    {
      label: "Payments",
      icon: <DollarSign className={iconCls} />,
      children: [
        { label: "Invoices" },
        { label: "Transaction History" },
      ],
    },
  ],

  // 🧠 Expert Room
  expert: [
    {
      label: "Mentors",
      icon: <Star className={iconCls} />,
      children: [
        { label: "Top Mentors" },
        { label: "Find a Mentor" },
      ],
    },
    {
      label: "AMA",
      icon: <Mic className={iconCls} />,
      children: [
        { label: "Live AMAs" },
        { label: "Past Sessions" },
      ],
    },
    {
      label: "Sessions",
      icon: <BookOpen className={iconCls} />,
      children: [
        { label: "1-on-1" },
        { label: "Group" },
      ],
    },
  ],

  // 🚀 Launch
  launch: [
    {
      label: "Beta Lab",
      icon: <Rocket className={iconCls} />,
      children: [
        { label: "Active Projects" },
        { label: "Testing Queue" },
      ],
    },
    {
      label: "Releases",
      icon: <CheckCircle className={iconCls} />,
      children: [
        { label: "Version Notes" },
        { label: "Release Schedule" },
      ],
    },
    {
      label: "Roadmap",
      icon: <ListChecks className={iconCls} />,
      children: [
        { label: "Upcoming Features" },
        { label: "Completed Milestones" },
      ],
    },
  ],

  // 📡 Signals
  signals: [
    {
      label: "Copy Trading",
      icon: <Megaphone className={iconCls} />,
      children: [
        { label: "Public Rooms" },
        { label: "Private Rooms" },
      ],
    },
    {
      label: "Premium Alerts",
      icon: <Megaphone className={iconCls} />,
      children: [
        { label: "Market Alerts" },
        { label: "Personal Alerts" },
      ],
    },
    {
      label: "Strategies",
      icon: <LineChart className={iconCls} />,
      children: [
        { label: "Backtested" },
        { label: "Community Shared" },
      ],
    },
  ],

  // 💼 Invest
  invest: [
    {
      label: "Pools",
      icon: <BarChart3 className={iconCls} />,
      children: [
        { label: "Trading Pools" },
        { label: "Private Pools" },
      ],
    },
    {
      label: "Funds",
      icon: <DollarSign className={iconCls} />,
      children: [
        { label: "Mutual Funds" },
        { label: "Hedge Funds" },
        { label: "Index Funds" },
      ],
    },
    {
      label: "Managed",
      icon: <UserCog className={iconCls} />,
      children: [
        { label: "Portfolio Management" },
        { label: "Wealth Advisors" },
      ],
    },
  ],

  // 📰 Media
  media: [
    {
      label: "News",
      icon: <Newspaper className={iconCls} />,
      children: [
        { label: "Market News" },
        { label: "Company Updates" },
      ],
    },
    {
      label: "Webinars",
      icon: <Video className={iconCls} />,
      children: [
        { label: "Upcoming Events" },
        { label: "Past Recordings" },
      ],
    },
    {
      label: "Gov Releases",
      icon: <FileText className={iconCls} />,
      children: [
        { label: "Regulatory Updates" },
        { label: "Policy Announcements" },
      ],
    },
    {
      label: "Journals",
      icon: <BookOpen className={iconCls} />,
      children: [
        { label: "Research Papers" },
        { label: "Market Reviews" },
      ],
    },
  ],

  // 🌐 Expo
  expo: [
    {
      label: "Announce",
      icon: <Megaphone className={iconCls} />,
      children: [
        { label: "New Events" },
        { label: "Partnerships" },
      ],
    },
    {
      label: "Host",
      icon: <Users className={iconCls} />,
      children: [
        { label: "Setup Expo" },
        { label: "Manage Booths" },
      ],
    },
    {
      label: "Join",
      icon: <UserCheck className={iconCls} />,
      children: [
        { label: "Upcoming Expos" },
        { label: "Participate" },
      ],
    },
  ],

    // 🌐 Library
  library: [
    {
      label: "Books",
      icon: <Megaphone className={iconCls} />,
      children: [
        { label: "All books" },
        { label: "Must read books" },
        { label: "Forex trading books" },
        { label: "Share market books" },
        { label: "Crypto books" },
      ],
    },
    {
      label: "Strategies",
      icon: <Users className={iconCls} />,
      children: [
        { label: "Popular Strategies" },
        { label: "Advanced Strategies" },
        { label: "RSI Strategies" },
        { label: "MACD Strategies" },
        { label: "Bollinger band Strategies" },
      ],
    },
    {
      label: "Knowledge base",
      icon: <UserCheck className={iconCls} />,
      children: [
        { label: "Recent market news" },
        { label: "Ask Market experts" },
      ],
    },
  ],

      // 🌐 News
  news: [
    {
      label: "India Market News",
      icon: <Megaphone className={iconCls} />,
      children: [
        { label: "SEBI Announcements" },
        { label: "Political Events" },
        { label: "Expert alerts" },
        { label: "Trending news" },        
      ],
    },
    {
      label: "Wall Street news",
      icon: <Users className={iconCls} />,
      children: [
        { label: "Trending" },
        { label: "Political Events" },
      ],
    },

  ],

};
